import { useState, useEffect } from 'react';
import { useUser } from '../context/UserContext';
import { ingresarLead, getLeadOrigenSelect } from '../api/apiConfig';
import { MdSave } from 'react-icons/md';

const IngresarLeads = () => {
  const { user } = useUser();
  const [rut, setRut] = useState('');
  const [origen, setOrigen] = useState('Gestión de ejecutivo');
  const [origenOptions, setOrigenOptions] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState('');

  useEffect(() => {
    const loadOrigenOptions = async () => {
      try {
        const result = await getLeadOrigenSelect();
        let options = [];
        if (result.body && typeof result.body === 'string') {
          options = JSON.parse(result.body);
        } else if (Array.isArray(result)) {
          options = result;
        }
        setOrigenOptions(options);
      } catch (error) {
        console.error('Error loading origen options:', error);
      }
    };
    loadOrigenOptions();
  }, []);

  const validateRut = (rutValue) => {
    const rutPattern = /^\d{7,8}-[\dkK]$/;
    return rutPattern.test(rutValue);
  };

  const groupedOptions = origenOptions.reduce((groups, option) => {
    const category = option.CATEGORIA;
    if (!groups[category]) {
      groups[category] = [];
    }
    groups[category].push(option);
    return groups;
  }, {});

  const handleRutChange = (e) => {
    let value = e.target.value.toUpperCase();
    
    // Remover todo excepto números y K
    const cleanValue = value.replace(/[^0-9K]/g, '');
    
    // Formatear solo si tiene contenido
    if (cleanValue.length > 0) {
      if (cleanValue.length === 1) {
        value = cleanValue;
      } else {
        // Separar los últimos dígitos del verificador
        const body = cleanValue.slice(0, -1);
        const dv = cleanValue.slice(-1);
        value = body + '-' + dv;
      }
    } else {
      value = '';
    }
    
    // Limitar longitud máxima (8 dígitos + guión + 1 dígito verificador)
    if (value.length > 10) {
      return;
    }
    
    setRut(value);
    setError('');
    setSuccess('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!rut.trim()) {
      setError('El RUT es obligatorio');
      return;
    }
    
    if (!validateRut(rut)) {
      setError('Formato de RUT inválido. Debe ser: 12345678-9');
      return;
    }
    
    setLoading(true);
    setError('');
    
    try {
      const fechaActual = new Date().toISOString().split('T')[0];
      
      const result = await ingresarLead(
        rut,
        user.ejecutivo_sistema_factoring,
        user.grupo,
        origen,
        fechaActual
      );
      
      const mensaje = result.mensaje || 'Lead ingresado exitosamente';
      setSuccess(mensaje);
      setRut('');
    } catch (err) {
      setError('Error al ingresar el lead: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-gray-800 mb-6">Ingresar Leads</h1>
      
      
      <div className="seccion-datos w-full">
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="rut" className="block text-sm font-medium text-gray-700 mb-2">
              RUT del Lead
            </label>
            <input
              type="text"
              id="rut"
              value={rut}
              onChange={handleRutChange}
              placeholder="12345678-9"
              className="w-2/3 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              maxLength="10"
            />
            <p className="text-xs text-gray-500 mt-1">
              Formato: sin puntos y con guión (ej: 12345678-9)
            </p>
          </div>
          
          <div>
            <label htmlFor="origen" className="block text-sm font-medium text-gray-700 mb-2">
              Origen
            </label>
            <select
              id="origen"
              value={origen}
              onChange={(e) => setOrigen(e.target.value)}
              className="w-2/3 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              {Object.entries(groupedOptions).map(([category, options]) => (
                <optgroup key={category} label={category}>
                  {options.map((option) => (
                    <option key={option.ORIGEN} value={option.ORIGEN}>
                      {option.ORIGEN}
                    </option>
                  ))}
                </optgroup>
              ))}
            </select>
          </div>
          
          {error && (
            <div className="text-red-600 text-sm bg-red-50 p-2 rounded">
              {error}
            </div>
          )}
          
          {success && (
            <div className="text-green-600 text-sm bg-green-50 p-2 rounded">
              {success}
            </div>
          )}
          
          <button
            type="submit"
            disabled={loading || !rut.trim()}
            className="btn-primary flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <MdSave className="w-4 h-4" />
            {loading ? 'Guardando...' : 'Guardar Lead'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default IngresarLeads;